import { createFileRoute } from '@tanstack/react-router'

import { PersonalInformationsPage } from '@/components/personal-informations/personal-informations-page'

export const Route = createFileRoute('/_authenticated/_layout/mon-profil')({
  component: PersonalInformationsPage,
  staticData: {
    hero: { subtitle: 'Gérez votre compte Massilia Voyages', title: 'Mon profil' },
  },
})
